export default "__VITE_ASSET__Zxh4ltU9__"